import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const SemanticBlock = () => {
    return (
        <FullWrapper className="semantic">
            <div className="semantic-block">
                <div className="semantic-block__subtitle">
                    Семантика для темы &laquo;Какой коллаген лучше выбрать?&raquo;
                </div>
                <div className="semantic-block__inner">
                    <div className="semantic-block__main">
                        <img src="/images/pic/medved/semantic.jpg" alt="" />
                    </div>
                    <div className="semantic-block__minor">
                        <div className="semantic-block__minor-description">
                            По&nbsp;теме &laquo;Какой коллаген лучше выбрать?&raquo;&nbsp;&mdash;
                            самым частотным запросом оказался &laquo;какой коллаген лучше&raquo;
                        </div>
                    </div>
                </div>
            </div>
        </FullWrapper>
    );
};
export default SemanticBlock;
